import React from 'react';
import styled from 'styled-components';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-light); `;
const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center; max-width: 720px; margin: 0 auto 2.5rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.75rem;
  @media (max-width: 900px) { grid-template-columns: repeat(4, 1fr); }
  @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
`;

const Chip = styled.div`
  padding: 0.85rem 0.6rem;
  text-align: center;
  border: 1px solid rgba(0,153,0,0.15);
  border-radius: 0.75rem;
  background: rgba(255,255,255,0.03);
  color: var(--text-color);
  font-weight: 600;
  font-size: 0.85rem;
  transition: transform 0.2s ease, border-color 0.2s ease;
  &:hover { transform: translateY(-2px); border-color: var(--primary-color); }
`;

const WALLETS = [
  'Trust Wallet', 'MetaMask', 'Binance Wallet', 'Coinbase Wallet', 'SafePal', 'TronLink',
  'Exodus', 'Atomic Wallet', 'Ledger Live', 'Trezor', 'Rainbow', 'Phantom (EVM)',
  'Bitget Wallet', 'imToken', 'TokenPocket', 'Math Wallet', 'Coin98', 'OKX Wallet',
];

const WalletCompatibility: React.FC = () => (
  <Section id="wallets">
    <Inner>
      <Head>
        <div className="tag">Wallet compatibility</div>
        <h2>Works on <span>50+ crypto wallets</span></h2>
        <p>Compatible with every major mobile and desktop USDT wallet. Screenshots and explorer links look native on each.</p>
      </Head>
      <Grid>
        {WALLETS.map((w) => (<Chip key={w}>{w}</Chip>))}
      </Grid>
      <p style={{ textAlign: 'center', marginTop: '2rem', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>…and more. Ask WhatsApp support if your wallet isn't listed.</p>
    </Inner>
  </Section>
);

export default WalletCompatibility;
